import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Divider,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Typography,
} from "antd";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import TmsCommonService from "../../../services/tms-common.service";
import { BaseContext } from "../../../contexts/BaseContext";
import Webcam from "react-webcam";
import VehicleServices from "../../../services/vehicle.services";
import { DutyServices } from "../../../services/duty-pass.service";
import TmsPrintTicket from "../../../components/tms-print-ticket/tms-print-ticket";
import TmsImageUpload from "../../../components/tms-customs/tms-image-upload";

const DutyPassAssign = ({ router }) => {
  const { userDetails, shiftData } = useContext(BaseContext);

  const [buttonLoading, setButtonLoading] = useState(false);

  const [departmentId, setDepartmentId] = useState();
  const [categoryId, setCategoryId] = useState();
  const [categories, setCategories] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [fileList, setFileList] = useState([]);

  const [name, setName] = useState("");
  const [designation, setDesignation] = useState();
  const [capturedImage, setCapturedImage] = useState(null);
  const [employeeExtID, setEmployeeExtID] = useState();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [array, setArray] = useState([]);
  const [externalPrint, setExternalPrint] = useState(false);
  const webcamRef = useRef(null);

  const captureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCapturedImage(imageSrc);
  };

  const recaptureImage = () => {
    setCapturedImage(null);
  };

  const printTicket = (data) => {
    setArray([
      ["Name", data?.name, { margin: "0", fontWeight: "bold" }],
      ["Designation", data?.designation, { margin: "0" }],
      ["Employee ID", data?.employeeId, { margin: "0" }], // replace
      [
        "Category",
        data?.category?.categoryName,
        { display: "none" },
        data?.category?.colorCode,
      ],
      [
        "Department",
        data?.department?.departmentName,
        { display: "none" },
        data?.category?.colorCode,
        data?.department?.signatureUrl,
      ],
      ["Pass Id", data?.transactionId, { margin: "0" }],
      ["footer", data?.transactionId, {}, {}, {}, null, data?.createdAt],
      ["image", data.photoUrl, {}],
    ]);
  };

  const handleSubmit = async () => {
    setButtonLoading(true);
    if (fileList.length === 0 && !capturedImage) {
      notification.info({
        message: "Please capture or upload a photo",
      });
      setButtonLoading(false);
      return;
    }
    let webcamimage = undefined;
    if (fileList.length === 0 || !fileList) {
      // Convert the base64 image data to a binary Blob
      const binaryData = atob(capturedImage.split(",")[1]);
      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }

      const blob = new Blob([uint8Array], { type: "image/jpeg" });

      let formData = new FormData();
      formData.append("file", blob);

      webcamimage = await TmsCommonService.uploadTempFile(
        formData,
        "person",
        userDetails.user.id
      );
    }

    if (name == "" || designation == "") {
      notification.info({
        message: "Please fill all the fields",
      });
      setButtonLoading(false);
      return;
    }

    try {
      const data = await DutyServices.createDutyPass({
        departmentId: departmentId,
        categoryId: categoryId,
        name: name,
        photoUrl: webcamimage ? webcamimage.path : fileList[0].url,
        designation,
        employeeId: employeeExtID,
      });
      notification.success({
        message: "Successfully created",
      });
      printTicket(data);
      setIsModalVisible(true);
      setExternalPrint(true);
      setButtonLoading(false);
      setDesignation("");
      setDesignation("");
      setName("");
      setDepartmentId("");
      setCategoryId("");
      setCapturedImage(null);
      setEmployeeExtID("");
      setFileList([]);
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setButtonLoading(false);
    }
  };

  useEffect(() => {
    shiftData && fetchData();
  }, [shiftData]);

  const fetchData = async () => {
    try {
      const departments = await VehicleServices.getDepartments();
      const counterName =
        shiftData?.shiftDetails?.counterName?.includes("Police") ||
        shiftData?.shiftDetails?.counterName?.includes("police");
      setDepartments(
        departments.filter((item) =>
          counterName ? item.departmentName?.includes("Police") : true
        )
      );
      const filters = [
        "ట్రాఫిక్",
        "All Round",
        "AR FORCE",
        "SPECIAL PARTY",
        "SDRF FORCE",
        "PROTOCOL",
        "CRIME PARTY",
        "POLICE SEVADAL",
        "సెక్టార్ - III",
        "సెక్టార్ - 1 కంట్రోల్ రూమ్",
        "సెక్టార్ - II ఆలయం లోపల",
        "సెక్టార్ - IV",
        "సెక్టార్ - IX",
        "సెక్టార్ - V",
        "సెక్టార్ - VI",
        "సెక్టార్ - VII",
        "సెక్టార్ - VIII",
      ];
      const categories = await VehicleServices.getCategorys();
      setCategories(
        categories.filter((item) =>
          counterName ? filters.includes(item.categoryName) : true
        )
      );
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
    }
  };

  return (
    <>
      <Row justify="center">
        <Typography.Title>Assign Duty Pass </Typography.Title>
      </Row>
      <Divider />
      <Row>
        <Col span={12}>
          <div
            style={{
              gap: "10px",
              display: "flex",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Name</label>
              <Input
                size="large"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter Name"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Designation</label>
              <Input
                size="large"
                value={designation}
                onChange={(e) => setDesignation(e.target.value)}
                placeholder="Enter Designation"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Employee ID</label>
              <Input
                size="large"
                value={employeeExtID}
                onChange={(e) => setEmployeeExtID(e.target.value)}
                placeholder="Enter Employee ID"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Department</label>
              <Select
                size="large"
                value={departmentId}
                onChange={(e) => {
                  setDepartmentId(e);
                }}
                style={{ width: "100%" }}
                placeholder="Select Department"
                showSearch
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {departments.map((department) => (
                  <Select.Option
                    key={department.id}
                    value={department.id}
                    label={department.departmentName}
                  >
                    {department.departmentName}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Category </label>
              <Select
                size="large"
                value={categoryId}
                onChange={(e) => {
                  setCategoryId(e);
                }}
                style={{ width: "100%" }}
                placeholder="Select Category"
                showSearch
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {categories.map((category) => (
                  <Select.Option
                    key={category.categoryId}
                    value={category.categoryId}
                    label={category.categoryName}
                  >
                    {category.categoryName}
                  </Select.Option>
                ))}
              </Select>
            </div>

            <br />
            <Button
              size="large"
              type="primary"
              onClick={(e) => {
                e.preventDefault();
                !buttonLoading && handleSubmit();
              }}
              loading={buttonLoading}
            >
              Submit
            </Button>
          </div>
        </Col>
        <Col span={12} style={{ display: "flex", flexDirection: "column" }}>
          <div
            className="container"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "400px",
                height: "330px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {capturedImage || fileList[0]?.url ? (
                <img
                  src={capturedImage || fileList[0]?.url}
                  alt="Captured"
                  width={400}
                  height={330}
                />
              ) : (
                <Webcam
                  className="poscapture"
                  width={400}
                  height={330}
                  ref={webcamRef}
                />
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginTop: "30px",
              justifyContent: "center",
            }}
          >
            {!capturedImage ? (
              <>
                <Button type="primary" onClick={captureImage}>
                  Capture
                </Button>
                <TmsImageUpload
                  fileList={fileList}
                  setFileList={setFileList}
                  router={router}
                  type="private"
                  accept={true}
                  className="w-100"
                />{" "}
              </>
            ) : (
              <>
                <Button type="primary" onClick={recaptureImage}>
                  Recapture
                </Button>
                <Button type="default" onClick={() => setCapturedImage(null)}>
                  Cancel
                </Button>
              </>
            )}
          </div>
        </Col>
        <Modal
          visible={isModalVisible}
          width={450}
          footer={null}
          closable={false}
          centered
          maskClosable={false}
        >
          <TmsPrintTicket
            data={array}
            setData={setArray}
            type="Duty Pass"
            from="Counter"
            externalPrint={externalPrint}
            setExternalPrint={setExternalPrint}
            setButtonLoading={setButtonLoading}
            setPrintTicketModal={setIsModalVisible}
            ticketType={""}
          />
        </Modal>
      </Row>
    </>
  );
};

export default withRouter(DutyPassAssign);
